// redux/slices/spacesSlice.js
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getSpaces } from '../../api/api';

export const fetchSpaces = createAsyncThunk(
  'spaces/fetchSpaces',
  async (_, { getState, rejectWithValue }) => {
    try {
      const uid = getState().auth.user?.id;
      if (!uid) throw new Error('No user');
      const res = await getSpaces(uid);
      return res.spaces || [];
    } catch (err) {
      return rejectWithValue(err.message || 'Failed to fetch spaces');
    }
  }
);

const spacesSlice = createSlice({
  name: 'spaces',
  initialState: {
    list: [],
    loading: false,
    error: null,
  },
  reducers: {
    clearSpaces(state) {
      state.list = [];
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchSpaces.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchSpaces.fulfilled, (state, action) => {
        state.loading = false;
        state.list = action.payload;
      })
      .addCase(fetchSpaces.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { clearSpaces } = spacesSlice.actions;
export default spacesSlice.reducer;
